import {RoomMetadata, SjMatrixMessageType} from '@/types/matrix';
import {
  EventType,
  JoinRule,
  MatrixClient,
  MatrixError,
  Preset
} from 'matrix-js-sdk';
import {env} from '@/config';
import {AppVariant, DocumentType} from '@/types/common';
import {getDirectChatRoomId} from './get-direct-chat-room-id';
import {updateDirectChatData} from './update-direct-chat-data';

const {APP_VARIANT} = env;

export const createDirectChat = async (
  invitedUserId: string,
  client: MatrixClient
): Promise<{room_id: string} | null> => {
  const previousRoomId = getDirectChatRoomId(invitedUserId);
  if (previousRoomId) {
    try {
      const joinedRoom = await client.joinRoom(previousRoomId);
      return {
        room_id: joinedRoom.roomId
      };
    } catch (error: unknown) {
      if (error instanceof MatrixError) {
        const {data} = error;
        if (
          data.errcode === 'M_FORBIDDEN' &&
          data.error === 'You are not invited to this room'
        ) {
          await client.knockRoom(previousRoomId);
          return Promise.resolve({room_id: previousRoomId});
        } else {
          console.error('Error while joining the room: ');
        }
      } else {
        console.error('Error while joining the room: ');
      }
    }
  }

  const metadata: RoomMetadata = {
    appVariant: APP_VARIANT as AppVariant,
    documentType: DocumentType.P2P,
    topic: 'Direct Chat'
  };
  const creationResult = await client.createRoom({
    preset: Preset.TrustedPrivateChat,
    invite: [invitedUserId],
    is_direct: true,
    initial_state: [
      {
        type: EventType.RoomJoinRules,
        content: {
          join_rule: JoinRule.Knock
        }
      },
      {
        type: SjMatrixMessageType.Metadata,
        content: metadata
      }
    ]
  });

  await updateDirectChatData(client, invitedUserId, creationResult.room_id);

  return creationResult;
};
